module.exports = __webpack_public_path__ + "img/Certifier1.388f0d78.png";